import { css } from 'styled-components';

export const base = css`
    html {
        font-family: var(--font-family);
        font-size: 16px;

        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        text-rendering: geometricPrecision;
    }

    /* Default focus */

    :focus-visible {
        outline: 2px solid var(--color-outline);
    }

    body {
        margin: 0;
        overflow-x: hidden;
        outline-offset: 2px;

        color: var(--color-text-primary);
        font-size: var(--font-size-body-md);
        line-height: var(--line-height-body);
    }
`;
